import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { AreaName } from 'domain/constants';
import { OperationType } from 'library/models/enums/OperationType';
import { createArea } from 'library/utils/helpers/AreaHelper';

import LazyRouteElement from './common/LazyRoute';

const RegisterEndCustomerPage = lazy(
	() => import('pages/register/RegisterEndCustomerPage')
);

const RegisterUnitPage = lazy(() => import('pages/register/RegisterUnitPage'));

export const getRegisterRoutes = (): React.JSX.Element[] => [
	<Route key={'consumer'} path="consumer">
		<Route
			index
			element={
				<LazyRouteElement
					area={createArea(AreaName.Consumer, OperationType.Create)}
					Component={RegisterEndCustomerPage}
					path={'consumer'}
				/>
			}
		/>
	</Route>,
	<Route
		key={'unit'}
		path={'unit'}
		element={
			<LazyRouteElement
				area={createArea(AreaName.Unit, OperationType.Create)}
				Component={RegisterUnitPage}
				path={'unit'}
			/>
		}
	/>,
];
